import React from "react";

const GuestCheckoutModal = ({ isOpen, onClose, onContinueGuest, onLogin }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-[9999] opacity-100 transition-opacity duration-300 pointer-events-auto p-4">
      <div className="w-full max-w-[420px] bg-white rounded-[20px] p-[25px] pb-10 shadow-xl transform translate-y-0 transition-transform duration-300 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-5 border-b border-[#eee] pb-2.5">
          <div></div>
          <button
            className="bg-transparent border-none text-2xl text-[#999] cursor-pointer p-0 transition-colors duration-200 hover:text-[#333]"
            onClick={onClose}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <p className="leading-[1.6] mt-[30px] text-black">
          Sign up to track orders, reorder fast, and get promo updates.
        </p>

        <div className="flex gap-2.5 mt-[28px] mb-2.5 flex-wrap">
          <button
            className="flex-1 min-w-[120px] bg-brand-orange text-black py-3.5 px-5 rounded-[25px] font-bold text-[15px] cursor-pointer transition-opacity duration-300 hover:opacity-80 disabled:opacity-50 border-none font-[inherit]"
            onClick={onLogin}
          >
            Login / Sign Up
          </button>

          <button
            className="flex-1 min-w-[120px] bg-[#f3f3f3] text-black py-3.5 px-5 rounded-[25px] font-bold text-[15px] cursor-pointer transition-opacity duration-300 hover:opacity-80 disabled:opacity-50 border-none font-[inherit]"
            onClick={onContinueGuest}
          >
            Continue as guest
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuestCheckoutModal;